<main>

  <div class="mx-4 mb-10">
    <h3 class="text-4xl font-bold mb-2">Novas Ocorrências</h3>
    <p class="text-sm">Dê tratamento à novas ocorrências como também ocorrências pendentes</p>
  </div>

  <!-- content wrapper -->
  <div class="bg-white p-5 border border-round">

    <!-- filtros aqui -->
    <div class="my-5">
      <app-event-admin-filter [hideEventStatus]="true" (submitFilter)="onFilterSubmit($event)"></app-event-admin-filter>
    </div>
    <app-event-table-list [hideTerminationDate]="true" [events]="events" [hasEvents]="hasEvents"></app-event-table-list>

    @if (pagination) {
      <app-paginator [paginationDetails]="pagination"
                     (pageChangeEvent)="onPageChange($event)"
      ></app-paginator>
    }
  </div>

</main>
